var currentYear = new Date().getFullYear();
const lastAge = 77;
const firstAge = 12;
const defaultAge = 35;

export const years: {[key: string]: any} = {
 startYear: currentYear - lastAge,
 endYear: currentYear - firstAge,
 defaultYear: currentYear - defaultAge,
};